// Utils
import TEXT from "../../../utils/globalText";
import { globalTextFormat } from "../../../utils/globalTextFormat";
import { linkIdentifier } from "../../../utils/linkIdentifier";
import CommonLayout from "../../_utils/CommonLayout";

// Components

// Components
import FileFormatMapper from "../../_utils/FileFormatMapper";
import AdditionalDetailsPreviewMapper from "../../_utils/TransactionCommonComponents/AdditionalDetailsPreviewMapper";
import Amount from "../../_utils/TransactionCommonComponents/Amount";
import CategorySelector from "../../_utils/TransactionCommonComponents/CategorySelector";
import SourceDestinationAccountDetail from "../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";

const ReimbursementRequestTxnConfirm = (props) => {
  // Callbacks
  const formatDate = (date) => {
    return `${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()} ${date.toLocaleString(
      "default",
      {
        month: "short",
      },
    )}, ${date.getFullYear()}`;
  };
  return (
    <div className="max-w-tab-width-normal Qsmd:pt-padding-lg pt-padding-md Qlg:px-padding-base px-padding-md">
      <CommonLayout>
        <div className="lg:max-w-[var(--create-box-width)]  w-width-full">
          <SourceDestinationAccountDetail
            type="destination"
            flow="beneficiary"
            txnPayLoad={props.txnPayLoad}
            setTxnPayLoad={props.setTxnPayLoad}
            page="confirm"
          />
        </div>

        <div className="lg:max-w-[var(--create-box-width)]  w-width-full">
          <Amount
            isPreview={true}
            txnPayLoad={props?.txnPayLoad}
          />
        </div>

        <div className="bg-primary-card rounded-border-radius-md p-padding-md w-width-full flex flex-col gap-gap-md Qlg:mb-margin-md">
          <span className="text-font-md font-semibold text-text-primary">
            {globalTextFormat(TEXT.Reimbursement_Details, [0, 1])}
          </span>

          <div className="w-width-full flex flex-col">
            <div className="w-width-full flex flex-col gap-gap-xs">
              <p
                className={`text-font-md text-text-primary overflow-hidden ${"break-all"}`}
              >
                <div className="flex justify-between items-start gap-gap-sm w-width-full">
                  <div className="flex-1 min-w-min-width-base gap-y-gap-xs flex flex-col">
                    <p className="break-all">
                      {linkIdentifier(props?.txnPayLoad?.expenseType)}
                    </p>
                    <p className="text-font-xs text-text-secondary">
                      Expense type
                    </p>
                  </div>
                </div>
              </p>
            </div>
            <div className="border-b border-primary-bg my-margin-sm" />
            <div className="w-width-full flex flex-col gap-gap-xs">
              <p
                className={`text-font-md text-text-primary overflow-hidden ${"break-all"}`}
              >
                <div className="flex justify-between items-start gap-gap-sm w-width-full">
                  <div className="flex-1 min-w-min-width-base gap-y-gap-xs flex flex-col">
                    <p className="break-all">
                      {formatDate(new Date(props?.txnPayLoad?.date))}
                    </p>
                    <p className="text-font-xs text-text-secondary">
                      Reimbursement date
                    </p>
                  </div>
                </div>
              </p>
            </div>
            <div className="border-b border-primary-bg my-margin-sm" />
            <div className="w-width-full flex flex-col gap-gap-xs">
              <p
                className={`text-font-md text-text-primary overflow-hidden ${"break-all"}`}
              >
                <div className="flex justify-between items-start gap-gap-sm w-width-full">
                  <div className="flex-1 min-w-min-width-base gap-y-gap-xs flex flex-col">
                    <p className="break-all">
                      {linkIdentifier(props?.txnPayLoad?.description) ||
                        "Not given"}
                    </p>
                    <p className="text-font-xs text-text-secondary">
                      Description (optional)
                    </p>
                  </div>
                </div>
              </p>
            </div>

            <div className="border-b border-primary-bg my-margin-sm" />
            <div className="w-width-full flex flex-col gap-gap-xs">
              <p
                className={`text-font-md text-text-primary overflow-hidden ${"break-all"}`}
              >
                <div className="flex justify-between items-start gap-gap-sm w-width-full">
                  <div className="flex-1 min-w-min-width-base gap-y-gap-xs flex flex-col">
                    <p className="break-all">
                      {linkIdentifier(props?.txnPayLoad?.uploadFile?.name)}
                    </p>
                    <p className="text-font-xs text-text-secondary">
                      Upload file
                    </p>
                  </div>

                  <div className="flex items-center justify-end">
                    <img
                      src={
                        ["PNG", "BMP", "JPEG", "JPG"].includes(
                          props?.txnPayLoad?.uploadFile?.type
                            ?.split("/")
                            ?.pop()
                            ?.toUpperCase(),
                        ) ||
                        FileFormatMapper(
                          props?.txnPayLoad?.uploadFile?.type
                            ?.split(".")
                            .pop()
                            ?.toLowerCase(),
                          "confirm",
                        )
                      }
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src =
                          "https://q2pay.in/new_assets/common/file_format/default.svg";
                      }}
                      alt="file"
                      className="w-icon-lg h-icon-lg shrink-0"
                    />
                  </div>
                </div>
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-gap-md">
          <CategorySelector
            previewMode={true}
            selectedCategory={props?.txnPayLoad?.selectedCategory}
            category={props?.txnPayLoad?.mergeCategory || []}
            IFSC={props?.txnPayLoad?.bankAccountIFSC}
            accountNumber={props?.txnPayLoad?.bankAccountNo}
            beneAccountId={props?.txnPayLoad?.beneAccountId}
            unassignCategories={[]}
            unassignlength={[]}
          />

          <div className="lg:max-w-[var(--create-box-width)] lg:w-width-full w-width-full">
            <AdditionalDetailsPreviewMapper
              mappingData={props.txnPayLoad.mergeCategory}
              previewImages={props?.previewImages}
            />
          </div>
        </div>
      </CommonLayout>

      <div className="h-mobile-create-header w-width-full Qmd:hidden block"></div>
    </div>
  );
};

export default ReimbursementRequestTxnConfirm;
